import { Link } from "react-router-dom";
import { SealCheck, ArrowRight } from "@phosphor-icons/react";
import { Container, Overline, SectionTitle } from "./Section";

function SubBlock({ s, label, more, index }) {
  return (
    <article id={s.id} aria-labelledby={`activite-heading-${index}`} data-testid={`activite-sub-${index}`} className="min-w-0 border-t border-[#D5DBE3] flex flex-col md:row-span-4 md:grid md:grid-rows-[subgrid]">
      <h3 id={`activite-heading-${index}`} data-testid={`activite-title-${index}`} className="pt-6 mb-4 font-heading text-xl sm:text-2xl font-semibold leading-snug tracking-normal text-[#0B1B3D]">{s.name}</h3>
      <p data-testid={`activite-hook-${index}`} className="mb-8 text-base text-[#2A2D34] leading-relaxed">{s.hook}</p>
      <div className="mb-8">
        <p data-testid={`activite-skills-label-${index}`} className="mb-5 text-sm font-semibold text-[#0B1B3D]">{label}</p>
        <ul data-testid={`activite-skills-${index}`} className="space-y-3">
          {s.skills.map((k, skillIndex) => (
            <li key={k} data-testid={`activite-skill-${index}-${skillIndex}`} className="flex items-start gap-3 text-sm text-[#5A6B7C] leading-relaxed">
              <span aria-hidden="true" className="mt-2.5 h-px w-3 shrink-0 bg-[#9AA5B1]" />
              <span>{k}</span>
            </li>
          ))}
        </ul>
      </div>
      {(s.badge || s.more) && (
        <div className="border-t border-[#E2E8F0] pt-5 flex flex-col items-start gap-5">
          {s.badge && (
            <span data-testid="pmp-badge" className="inline-flex items-start gap-2 text-[#5A6B7C] text-xs font-medium leading-relaxed">
              <SealCheck size={16} weight="light" aria-hidden="true" className="shrink-0 mt-0.5" />
              {s.badge}
            </span>
          )}
          {s.more && (
            <Link to={s.more} data-testid={`activite-more-${index}`} className="inline-flex items-center gap-2 text-sm font-medium text-[#0B1B3D] hover:text-[#5A6B7C] transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#0B1B3D]">
              {more}
              <ArrowRight size={14} weight="light" aria-hidden="true" />
            </Link>
          )}
        </div>
      )}
    </article>
  );
}

export default function Activites({ t }) {
  const a = t.activites;
  return (
    <section id="activites" className="py-24 lg:py-32 bg-white">
      <Container>
        <Overline testid="activites-overline">{a.overline}</Overline>
        <div className="grid lg:grid-cols-2 gap-12 mb-20">
          <SectionTitle testid="activites-title">{a.title}</SectionTitle>
          <p className="text-base md:text-lg leading-relaxed text-[#5A6B7C] lg:pt-2" data-testid="activites-text">{a.text}</p>
        </div>

        <div id="gestion-projets-developpement-commercial" className="border-t-2 border-[#0B1B3D] pt-10" data-testid="bu1-block">
          <p className="font-heading text-sm font-semibold tracking-[0.2em] uppercase text-[#9AA5B1] mb-4">{a.bu1.label}</p>
          <h2 className="font-heading text-2xl md:text-3xl font-semibold tracking-tight text-[#0B1B3D] mb-10" data-testid="bu1-name">
            {a.bu1.name}
          </h2>
          <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 mb-16">
            <p className="lg:col-span-5 text-xl md:text-2xl font-medium text-[#2A2D34] leading-snug" data-testid="bu1-title">{a.bu1.title}</p>
            <p className="lg:col-span-7 text-base leading-relaxed text-[#5A6B7C]" data-testid="bu1-text">{a.bu1.text}</p>
          </div>
          <div className="grid md:grid-cols-2 gap-x-12 lg:gap-x-16 gap-y-12 md:gap-y-0">
            {a.bu1.sub.map((s, i) => (
              <SubBlock key={s.id} s={s} label={a.bu1.skillsLabel} more={t.pages.common.more} index={i} />
            ))}
          </div>
          <p className="mt-12 border-l-2 border-[#0B1B3D] pl-6 text-base md:text-lg text-[#2A2D34] leading-relaxed max-w-4xl" data-testid="bu1-continuity">
            {a.bu1.continuity}
          </p>
        </div>
      </Container>
    </section>
  );
}
